import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';

const faqData = [
  {
    question: 'How often are campaign reports updated?',
    answer: 'Campaign reports are updated every minute. All campaign report times are based on Coordinated Universal Time (UTC).',
  },
  {
    question: 'How to Become a Publisher?',
    answer: 'To ensure high-quality and consistent traffic for our advertisers, we only invite publishers to join our network and do not accept applications. This approach also helps us use our resources efficiently. Thank you for your understanding.',
  },
  {
    question: 'What targeting options are available?',
    answer: 'We offer granular targeting options including geographic location, device type, operating system, browser, system targeting, IP restrictions, and more for precise audience reach.',
  },
  {
    question: 'What are the minimum bids for each ad format?',
    answer:   
    <div>
      <p>Pop-up Ads Minimum CPC: $0.0002</p>
      <p>Push Notifications Minimum CPC: $0.01</p>
      <p>In-Page Push Ads Minimum CPC: $0.005</p>
      <p>Native Ads Minimum CPC: $0.005</p>
      <p>Banner Ads Minimum CPC: $0.005</p>
    </div>
  
  },
  {
    question: 'What is the typical approval time for an ad campaign?',
    answer: 'On weekdays (Monday through Friday), your ad campaign is typically reviewed within 24 hours. On weekends (Saturday and Sunday), there may be some delays.',
  },
  {
    question: 'What is the minimum budget to start advertising?',
    answer: 'You can start an advertising campaign with as little as $30.'
  }
 
];

const FaqSection = () => {
  return (
    <section id="help" className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <motion.h2 
          className="text-3xl md:text-4xl font-bold text-center mb-4 text-glow-purple"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
        >
          Frequently Asked Questions
        </motion.h2>
        <motion.p 
          className="text-lg text-cyber-text-secondary text-center mb-8 md:mb-12 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Find answers to common questions about our platform, services, and advertising solutions.
        </motion.p>

        <motion.div 
          className="max-w-3xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          {faqData.length > 0 ? (
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((item, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="glassmorphism mb-2 rounded-lg p-2 border-neon-purple/30 hover:border-neon-pink/50 transition-colors"
                >
                  <AccordionTrigger className="hover:text-glow-pink">
                    <div className="flex items-center">
                      <HelpCircle className="h-5 w-5 mr-3 text-neon-purple group-hover:text-neon-pink transition-colors" />
                      {item.question}
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-base leading-relaxed">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          ) : (
            <p className="text-center text-cyber-text-secondary py-8">
              No questions available at the moment.
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default FaqSection;
